<script lang="ts">
  import { Button, Col, Form, Input, Label, Row } from "sveltestrap";
  import { InlineFormwithLabel,Login, Password, Username } from "../../../../utils/Constant/Constant";
</script>

<h6>{InlineFormwithLabel}</h6>
<Form class="theme-form mt-3">
  <Row>
    <Col xxl="4" class="mb-3 d-flex align-items-center">
      <Label class="col-form-label pe-2" for="inputInlineUsername"
        >{Username}</Label
      >
      <Input
        id="inputInlineUsername"
        type="text"
        name="inputUsername"
        placeholder="Username"
        autocomplete="off"
      />
    </Col>
    <Col xxl="4" class="mb-3 d-flex align-items-center">
      <Label class="col-form-label pe-2" for="inputInlinePassword"
        >{Password}</Label
      >
      <Input
        id="inputInlinePassword"
        type="password"
        name="inputPassword"
        placeholder="Password"
        autocomplete="off"
      />
    </Col>
    <Col xxl="4" class="mb-3 d-flex align-items-center">
      <Button color="primary">{Login}</Button>
    </Col>
  </Row>
</Form>
